export default "__VITE_ASSET__BKImfyZz__"